module.exports = __webpack_public_path__ + "static/media/incPlusSvg.accc186e.svg";